import React, { useState, useEffect } from "react"
import { CardBody, Container, Row, Col, Card, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import { URLS } from "../../Url"
import axios from "axios"

function ViewCustomer() {
  const navigate = useHistory()
  const [orders, setOrders] = useState([])

  let custid = sessionStorage.getItem("Custid")

  const getAuthToken = () => {
    try {
      const authUser = localStorage.getItem("authUser")
      if (!authUser) return null
      const tokenJson = JSON.parse(authUser)
      return tokenJson?.token || null
    } catch (error) {
      console.error("Error parsing auth token:", error)
      return null
    }
  }

  const token = getAuthToken()

  const getCustomerOrders = async () => {
    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    try {
      const response = await axios.post(
        URLS.GetOneCustomers,
        { userId: custid },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      setOrders(response?.data?.orders || [])
    } catch (error) {
      toast.error("Failed to fetch Customer data")
    }
  }

  useEffect(() => {
    getCustomerOrders()
  }, [])

  const getStatusBadge = status => {
    switch (status.toLowerCase()) {
      case "new":
        return "primary"
      case "processing":
        return "warning"
      case "completed":
        return "success"
      case "cancelled":
        return "danger"
      default:
        return "secondary"
    }
  }

  const getPaymentBadge = status => {
    switch (status.toLowerCase()) {
      case "success":
        return "success"
      case "pending":
        return "warning"
      case "failed":
        return "danger"
      default:
        return "secondary"
    }
  }

  const formatDate = dateString => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }
    return new Date(dateString).toLocaleDateString("en-US", options)
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Customer Details"
          breadcrumbItem="Order Information"
        />
        <Row className="mb-2">
          <Col>
            <Button
              onClick={() => navigate.goBack()}
              className="text-white"
              style={{ float: "right" }}
              color="primary"
              size="sm"
            >
              <i className="far fa-arrow-alt-circle-left me-2"></i>
              Back
            </Button>
          </Col>
        </Row>
        {orders.length > 0 ? (
          orders.map(order => (
            <Card key={order._id} className="mb-2">
              <CardBody>
                <Row className="align-items-center mb-2">
                  <Col md={6}>
                    <h4 className="mb-0">
                      <strong>Order #</strong> {order.orderUnquieId}
                    </h4>
                    <small className="text-muted">
                      Placed on {formatDate(order.logCreatedDate)}
                    </small>
                  </Col>
                  <Col md={6} className="text-md-end mt-3 mt-md-0">
                    <b
                      className={`text-${getStatusBadge(
                        order.status
                      )} py-2 px-3`}
                    >
                      {order.status.toUpperCase()}
                    </b>
                    <b
                      className={`text-${getPaymentBadge(
                        order.paymentStatus
                      )} py-2 px-3`}
                    >
                      PAYMENT: {order.paymentStatus.toUpperCase()}
                    </b>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col lg={6} className="mb-4 mb-lg-0">
                    <h5 className="font-size-16 border-bottom pb-2 mb-2">
                      <i className="fas fa-truck me-2"></i>
                      Shipping Information
                    </h5>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "100px" }}>
                        <strong>Name:</strong>
                      </div>
                      <div>{order.addressUserName}</div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "100px" }}>
                        <strong>Address:</strong>
                      </div>
                      <div>
                        {order.addressLine1}
                        {order.addressLine2 && <>, {order.addressLine2}</>}
                      </div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "100px" }}>
                        <strong>City/State:</strong>
                      </div>
                      <div>
                        {order.cityName}, {order.stateName}
                      </div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "100px" }}>
                        <strong>Country:</strong>
                      </div>
                      <div>{order.countryName}</div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "100px" }}>
                        <strong>Pincode:</strong>
                      </div>
                      <div>{order.pincode}</div>
                    </div>
                    <div className="d-flex">
                      <div style={{ minWidth: "100px" }}>
                        <strong>Type:</strong>
                      </div>
                      <div className="text-capitalize">{order.addressType}</div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <h5 className="font-size-16 border-bottom pb-2 mb-2">
                      <i className="fas fa-credit-card me-2"></i>
                      Payment Details
                    </h5>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "140px" }}>
                        <strong>Payment Method:</strong>
                      </div>
                      <div className="text-capitalize">
                        {order.paymentMethod}
                      </div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "140px" }}>
                        <strong>Transaction ID:</strong>
                      </div>
                      <div>{order.transactionId}</div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "140px" }}>
                        <strong>Amount Paid:</strong>
                      </div>
                      <div>₹{order.paymentAmount.toFixed(2)}</div>
                    </div>
                    <div className="d-flex mb-2">
                      <div style={{ minWidth: "140px" }}>
                        <strong>Currency:</strong>
                      </div>
                      <div>{order.paymentCurrency.toUpperCase()}</div>
                    </div>
                    <div className="d-flex">
                      <div style={{ minWidth: "140px" }}>
                        <strong>Order Total:</strong>
                      </div>
                      <div>
                        <strong>₹{order.payableAmount.toFixed(2)}</strong>
                      </div>
                    </div>
                  </Col>
                </Row>
                <h5 className="font-size-16 border-bottom pb-2 mb-2">
                  <i className="fas fa-shopping-basket me-2"></i>
                  Order Items
                </h5>
                <div className="table-responsive">
                  <Table className="table-centered table-nowrap">
                    <thead className="bg-light">
                      <tr>
                        <th style={{ width: "40%" }}>Product</th>
                        <th className="text-center">Variant</th>
                        <th className="text-center">Options</th>
                        <th className="text-center">Qty</th>
                        <th className="text-end">Price</th>
                        <th className="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.orderProducts.map((product, index) => (
                        <tr key={index}>
                          <td>
                            <div className="d-flex align-items-center">
                              {product.productImages &&
                                product.productImages.length > 0 && (
                                  <img
                                    src={`${URLS.Base}${product.productImages[0]}`}
                                    alt={product.productName}
                                    className="rounded me-3"
                                    style={{ width: "60px" }}
                                  />
                                )}
                              <div>
                                <h5 className="font-size-14 mb-1">
                                  {product.productName}
                                </h5>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">{product.variantName}</td>
                          <td className="text-center">
                            {product.variantOptionNames &&
                              product.variantOptionNames.join(", ")}
                          </td>
                          <td className="text-center">{product.quantity}</td>
                          <td className="text-end">
                            ₹{parseFloat(product.price).toFixed(2)}
                          </td>
                          <td className="text-end">
                            ₹
                            {(
                              parseFloat(product.price) *
                              parseInt(product.quantity)
                            ).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <div className="row mt-2">
                  <div className="col-sm-6"></div>
                  <div className="col-sm-6">
                    <div className="float-sm-end">
                      <Table className="table table-sm table-borderless">
                        <tbody>
                          <tr>
                            <td className="text-end pe-3">
                              <strong>Subtotal:</strong>
                            </td>
                            <td style={{ width: "120px" }} className="text-end">
                              ₹{order.totalAmount.toFixed(2)}
                            </td>
                          </tr>
                          {parseFloat(order.couponDiscount) > 0 && (
                            <tr>
                              <td className="text-end pe-3">
                                <strong>Coupon Discount:</strong>
                              </td>
                              <td className="text-end text-danger">
                                -₹{order.couponDiscount}
                              </td>
                            </tr>
                          )}
                          <tr className="border-top">
                            <td className="text-end pe-3 pt-3">
                              <strong>Total:</strong>
                            </td>
                            <td className="text-end pt-3">
                              <strong>₹{order.payableAmount.toFixed(2)}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          ))
        ) : (
          <Card>
            <CardBody className="text-center py-5">
              <i className="bx bx-package font-size-24 text-muted mb-2" />
              <h4>No Orders Found</h4>
              <p className="text-muted">
                This customer hasn't placed any orders yet.
              </p>
            </CardBody>
          </Card>
        )}
      </Container>
      <ToastContainer />
    </div>
  )
}

export default ViewCustomer
